var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseBlankSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4773 1.33636C11.8196 1.24368 12.1804 1.24368 12.5227 1.33636C12.92 1.44395 13.2546 1.7066 13.5216 1.91623C13.5471 1.93625 13.572 1.95578 13.5962 1.97465L20.3785 7.24977C20.4046 7.27007 20.4305 7.29017 20.4562 7.31011C20.8329 7.6024 21.1647 7.8599 21.4119 8.19421C21.6289 8.48759 21.7906 8.8181 21.8889 9.1695C22.001 9.56992 22.0006 9.98993 22.0001 10.4667C22 10.4992 22 10.532 22 10.5651V17.8386C22 18.3657 22 18.8204 21.9694 19.195C21.9371 19.5904 21.8658 19.9836 21.673 20.362C21.3854 20.9264 20.9264 21.3854 20.362 21.673C19.9836 21.8658 19.5904 21.9371 19.195 21.9694C18.8204 22 18.3657 22 17.8386 22H6.16142C5.63428 22 5.17953 22 4.80496 21.9694C4.40961 21.9371 4.0164 21.8658 3.63802 21.673C3.07353 21.3854 2.61459 20.9264 2.32697 20.362C2.13417 19.9836 2.06286 19.5904 2.03056 19.195C1.99995 18.8204 1.99997 18.3657 1.99999 17.8385L1.99999 10.5651C1.99999 10.532 1.99995 10.4992 1.99992 10.4667C1.9994 9.98993 1.99895 9.56992 2.11103 9.1695C2.20939 8.8181 2.37104 8.48759 2.58803 8.19421C2.83529 7.85991 3.1671 7.6024 3.54373 7.31012C3.56943 7.29018 3.59533 7.27007 3.62144 7.24977L10.4037 1.97465C10.428 1.95578 10.4529 1.93625 10.4784 1.91623C10.7454 1.7066 11.0799 1.44395 11.4773 1.33636Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBlankSolid);
export default __webpack_public_path__ + "static/media/house-blank-solid.838fe7125f33ad02fa60d943cae0ac10.svg";
export { ForwardRef as ReactComponent };